import HELPERS from "../utils/helpers";

const API_MANAGER = {
  refreshToken: (data) => {
    return fetch(`${process.env.NEXT_PUBLIC_AUTH_V2}users/refresh-token/`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
    });
  },
  login: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.request({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      // baseURL: "https://auth-api.dev.edly.co/api/v1",
      url: "users/login",
      method: "POST",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  socialLogin: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.request({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: "users/social-login",
      method: "POST",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  resendOtp: (values) => {
    const formData = HELPERS.convertToFormData(values);
    return HELPERS.request({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/resend-otp`,
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  adminVerifyOtp: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.request({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/verify-otp`,
      method: "POST",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    }).catch((err) => {
      // console.log("catch error :", err.response, err.response.status)
      throw err;
    });
  },

  adminForgotPassword: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.request({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/forgot-password/`,
      method: "PATCH",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    }).catch((err) => {
      // console.log("catch error :", err.response, err.response.status);
      // message.error("Something Went Wrong");
      throw err;
    });
  },

  getAdminStudentOverview: (
    date_range,
    funding_semester,
    funding_semester_range,
    utm_sources,
    ibr_initiated_by,
    ibr_status,
    loan_type,
    school_type,
    school,
    borrower_type,
  ) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/overview?is_active=True${
        date_range ? "&date_range=" + date_range : ""
      }${funding_semester ? "&funding_semester=" + funding_semester : ""}${
        funding_semester_range
          ? "&funding_semester_range=" + funding_semester_range
          : ""
      }${utm_sources ? "&utm_source=" + utm_sources : ""}
      ${ibr_initiated_by ? "&ibr_initiated_by=" + ibr_initiated_by : ""}
      ${ibr_status ? "&ibr_status=" + ibr_status : ""}
      ${loan_type ? "&loan_type=" + loan_type : ""}
      ${school_type ? "&school_type=" + school_type : ""}
      ${school ? "&school=" + school : ""}
      ${borrower_type ? "&borrower_type=" + borrower_type : ""}`,
      method: "GET",
    });
  },

  getAdminStudentOverview1: (data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/overview?is_active=True${
        data?.date_range ? "&date_range=" + data?.date_range : ""
      }${data?.school_type ? "&school_type=" + data?.school_type : ""}${
        data?.school ? "&school=" + data?.school : ""
      }${data?.loan_type ? "&loan_type=" + data?.loan_type : ""}${
        data?.industry
          ? "&industry=" +
            (Array.isArray(data.industry)
              ? data.industry.join(",")
              : data.industry)
          : ""
      }${data?.borrower_type ? "&borrower_type=" + data?.borrower_type : ""}${
        data?.initiated_by ? "&ibr_initiated_by=" + data?.initiated_by : ""
      }
      ${data?.servicer ? "&servicer=" + data?.servicer : ""}
      ${data?.lender_bank ? "&lender_bank=" + data?.lender_bank : ""}
      ${data?.utm_source ? "&utm_source=" + data?.utm_source : ""}`,
      method: "GET",
    });
  },

  getStudentExportOverview: (
    date_range,
    funding_semester,
    funding_semester_range,
    utm_sources,
    initiated_by,
    ibr_status,
    loan_type,
    school_type,
    school,
    borrower_type,
    industry,
  ) => {
    // const formData = HELPERS.convertToFormData(data)
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/overview/csv?is_active=True${
        date_range ? "&date_range=" + date_range : ""
      }${funding_semester ? "&funding_semester=" + funding_semester : ""}${
        funding_semester_range
          ? "&funding_semester_range=" + funding_semester_range
          : ""
      }${utm_sources ? "&utm_source=" + utm_sources : ""}
      ${initiated_by ? "&ibr_initiated_by=" + initiated_by : ""}
      ${ibr_status ? "&ibr_status=" + ibr_status : ""}
      ${loan_type ? "&loan_type=" + loan_type : ""}
      ${school_type ? "&school_type=" + school_type : ""}
      ${school ? "&school=" + school : ""}
      ${borrower_type ? "&borrower_type=" + borrower_type : ""}
      ${industry ? "&industry=" + industry : ""}`,
      // data: formData,
      method: "POST",
    });
  },

  getStudentExportOverview1: (
    date_range,
    utm_sources,
    initiated_by,
    loan_type,
    school_type,
    borrower_type,
    school,
    servicer,
    lender_bank,
    industry,
  ) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/overview/csv?is_active=True${
        date_range ? "&date_range=" + date_range : ""
      }${utm_sources ? "&utm_source=" + utm_sources : ""}${
        initiated_by ? "&ibr_initiated_by=" + initiated_by : ""
      }${loan_type ? "&loan_type=" + loan_type : ""}${
        servicer ? "&servicer=" + servicer : ""
      }${lender_bank ? "&lender_bank=" + lender_bank : ""}${
        school_type ? "&school_type=" + school_type : ""
      }${borrower_type ? "&borrower_type=" + borrower_type : ""}${
        school ? "&school=" + school : ""
      }
      ${industry ? "&industry=" + industry : ""}`,

      // data: formData,
      method: "POST",
    });
  },

  getIbrListExportOverview: (
    date_range,
    funding_semester,
    funding_semester_range,
    utm_sources,
    stage_status,
    data,
  ) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/overview/csv?is_active=True${
        date_range ? "&date_range=" + date_range : ""
      }${funding_semester ? "&funding_semester=" + funding_semester : ""}${
        funding_semester_range
          ? "&funding_semester_range=" + funding_semester_range
          : ""
      }${utm_sources ? "&utm_source=" + utm_sources : ""}${
        stage_status ? "&stage_status" + stage_status : ""
      }`,
      data: formData,
      method: "POST",
    });
  },
  getIbrListExportOverview1: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/overview/csv?is_active=True`,
      data: formData,
      method: "POST",
    });
  },

  fundingInvestorList: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/funding-investor-list/`,
      method: "GET",
    });
  },

  getUniversities: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `school/`,
      params,
      method: "GET",
    });
  },

  studentListNew: (
    pageNo,
    limit,
    stageStatus,
    userStr,
    search,
    isActiveIbr,
    rangeFilter,
  ) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/?limit=${10}&${pageNo && "page=" + pageNo}${
        stageStatus && "&stage_status=" + stageStatus
      }${
        rangeFilter?.funding_semester_range
          ? "&funding_semester_range=" + rangeFilter?.funding_semester_range
          : ""
      }${userStr ? "&users=" + userStr : ""}${
        rangeFilter?.date_range ? "&date_range=" + rangeFilter?.date_range : ""
      }${
        rangeFilter?.funding_semester
          ? "&funding_semester=" + rangeFilter?.funding_semester
          : ""
      }${search && "&search=" + search}${
        isActiveIbr && "&is_active=" + isActiveIbr
      }`,
      method: "GET",
    });
  },

  UserListNew: (Usersstr, search = "", pageNo = "") => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/?user_type=${10}&${Usersstr && "users=" + Usersstr}${
        search && "&search=" + search
      }${pageNo && "&page=" + pageNo}`,
      method: "GET",
    });
  },
  sendBulkInvestor: (data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/bulk-funding-investor/`,
      method: "POST",
      data: data,
    });
  },
  getBulkInvestor: (params, data) => {
    // console.log(atype, dtype);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/pending/`,
      params,
      method: "GET",
    });
  },

  sendBulkBank: (data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/bank-send/`,
      method: "POST",
      data: data,
    });
  },

  servicerAccountSetup: (data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/move-to-funding-investor/`,
      method: "POST",
      data: data,
    });
  },

  getSchoolList: (pageNo, search, term, active, type) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school-list/?limit=10&page=${pageNo}${
        search ? "&search=" + search : ""
      }${active != "" ? "&is_active=" + active : ""}${
        term != "" ? "&has_terms=" + term : ""
      }${type && type != "" ? "&school_type=" + type : ""}`,
      method: "GET",
    });
  },
  getAllSchools: (typeFilter, isActiveFilter, termsFilter) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/schools/overview/csv?${
        typeFilter.length != 0 ? "school_type=" + typeFilter : ""
      }${isActiveFilter.length != 0 ? "&is_active=" + isActiveFilter : ""}${
        termsFilter.length != 0 ? "&has_terms=" + termsFilter : ""
      }`,
      method: "GET",
    });
  },
  addSchool: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school-list/`,
      method: "POST",
      data: formData,
      headers: {},
    });
  },
  getMajorsList: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/major-list/`,
      method: "GET",
    });
  },
  getSchool: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school-list/${id}/`,
      method: "GET",
    });
  },
  refundsTerms: (school_uuid, data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school-list/${school_uuid}/refund-terms/`,
      method: "POST",
      data,
    });
  },
  updateRefundsTerms: (school_uuid, data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school-list/${school_uuid}/refund-terms/`,
      method: "PATCH",
      data,
    });
  },
  getAvailableProgramList: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school/${id}/available-programs/`,
      method: "GET",
    });
  },
  updateAvailableProgramList: (id, data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school/${id}/available-programs/`,
      method: "PATCH",
      data: formData,
    });
  },
  getExportAvailableProgram: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/schools/degree-list/csv/${id}/`,
      method: "GET",
    });
  },
  getBankInfo: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school/${id}/school-bank-info`,
      method: "GET",
    });
  },
  getSchoolTermsCSV: (id, filter) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `/students/${id}/export-loan-terms`,
      params: { ...filter },
      method: "GET",
    });
  },
  postBankInfo: (id, data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school/${id}/school-bank-info`,
      method: "POST",
      data: formData,
    });
  },
  patchBankInfo: (id, data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school/${id}/school-bank-info`,
      method: "PATCH",
      data: formData,
    });
  },
  getSchoolDataList: (schoolName, pageNo, filter) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/loan-terms/`,
      params: { school_uuid: schoolName, page: pageNo, ...filter },
      method: "GET",
    });
  },

  updateSchool: (data, uuid) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/school-list/${uuid}/`,
      method: "PATCH",
      data: formData,
      headers: {},
    });
  },

  // getSchoolStaffList: (pageNo, value) => {
  //   const newSearchValue = value ? value.replace("+", "%2B") : "";
  //   return HELPERS.secureRequest({
  //     baseURL: process.env.NEXT_PUBLIC_STUDENT,
  //     url: `school-staff/?limit=${10}&${pageNo && "page=" + pageNo}&${
  //       newSearchValue && "search=" + newSearchValue
  //     }`,
  //     method: "GET",
  //   });
  // },
  getSchoolStaffList: (pageNo, value) => {
    const newSearchValue = value ? value.replace("+", "%2B") : "";
    const params = new URLSearchParams();
    params.append("limit", 10);
    if (pageNo) params.append("page", pageNo);
    if (value) params.append("search", value);

    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `school-staff/?${params.toString()}`,
      method: "GET",
    });
  },

  getSchoolStaffListById: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `school-staff/${uuid}/`,
      method: "GET",
    });
  },
  updateSchoolStaff: (data) => {
    const updatedData = JSON.stringify(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH_V2,
      url: `users/school-staff-update/`,
      method: "PATCH",
      data: updatedData,
      headers: { "Content-Type": "application/json" },
    });
  },
  postStudentSignup: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.request({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `/users/signup`,
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  codingSchoolAction: (action) => {
    const formData = HELPERS.convertToFormData(action);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH_V2,
      url: `users/school-staff-update/`,
      method: "PATCH",
      data: formData,
    });
  },
  getApplicationList: (pageNo, search, data, pageSize) => {
    const newSearchValue = search.replace("+", "%2B");

    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value),
    );
    const formData = HELPERS.convertToFormData(filteredData);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/applications/?limit=${pageSize}&page=${pageNo}${
        newSearchValue ? "&search=" + newSearchValue : ""
      }`,
      data: formData,
      method: "POST",
    });
  },
  adminStudentDetail: (studentUUID, ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentUUID}/ibr/${ibrID}/personal-ibr-details/`,
      method: "GET",
    });
  },
  adminLinkedAppDetails: (ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/ibr/${ibrID}/linked-application-details/`,
      method: "GET",
    });
  },
  getIbrDocumentList: (studentUUID, ibrID, title) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentUUID}/ibr/${ibrID}/document/${
        title ? "?is_active=False" : ""
      }${title ? "&title=" + title : ""}
      `,
      method: "GET",
    });
  },

  getIbrDeactivatedDocumentList: (studentUUID, ibrID, title) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentUUID}/ibr/${ibrID}/deactivated-document/${
        title ? "?is_active=False" : ""
      }${title ? "&title=" + title : ""}
      `,
      method: "GET",
    });
  },

  uploadCustomDocument: (studentUUID, ibrID, data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentUUID}/ibr/${ibrID}/upload-custom-document/`,
      data: formData,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getBankLinkDetails: (ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/account-details/${ibrID}/`,
      method: "GET",
    });
  },
  resetBankLinkDetails: (studentUUID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/account-relink/${studentUUID}/`,
      method: "POST",
    });
  },
  getTranscriptDetail: (studentUUID, ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentUUID}/ibr/${ibrID}/transcript/transcript_detail`,
      method: "GET",
    });
  },
  calculateDTI: (stuId, ibrId, data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${stuId}/ibr/${ibrId}/creditor/dti-calculator/`,
      method: "POST",
      data: data,
    });
  },
  getRefreshedData: (studentUUID, ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentUUID}/ibr/${ibrID}/transcript/academic-summary-update/`,
      method: "GET",
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  postCodingSchool: (studentUUID, ibrID, data, slug) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentUUID}/ibr/${ibrID}/admin-approval-status/${slug}/`,
      method: "PATCH",
      data: formData,
    });
  },
  updateReserveAmount: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/update-reserve-amount/`,
      method: "PATCH",
      data: formData,
    });
  },

  addAdvanceTiersAction: (studentUUID, ibrID, data, slug) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentUUID}/ibr/${ibrID}/admin-approval-status/${slug}/`,
      method: "PATCH",
      data: data,
    });
  },
  postcertificationAction: (studentUUID, ibrID, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentUUID}/ibr/${ibrID}/admin-approval-status/certification/`,
      method: "PATCH",
      data: form_data,
    });
  },

  cosignerReleaseAction: (studentUUID, ibrID, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentUUID}/ibr/${ibrID}/admin-approval-status/release_cosigner/`,
      method: "PATCH",
      data: form_data,
    });
  },
  getFundingInvestors: (studentUUID, ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentUUID}/ibr/${ibrID}/funding-investor/`,
      method: "GET",
    });
  },
  patchFundingInvestor: (ibrID, studentUUID, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentUUID}/ibr/${ibrID}/funding-investor/`,
      method: "PATCH",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getEstimation: (StudentId, IbrId, salary, interestRate, maturity, terms) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${StudentId}/ibr/${IbrId}/calculator?maturity=${maturity}&interest_rate=${interestRate}&salary=${salary}&terms=${terms}`,
      method: "GET",
    });
  },
  // adminActions: (studentId, IbrId) => {
  //   return HELPERS.secureRequest({
  //     baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
  //     url: `students/${studentId}/ibr/${IbrId}/admin-action-detail`,
  //     method: "GET",
  //   });
  // },

  getOfferApprovalDetails: (studentID, ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentID}/ibr/${ibrID}/creditor/credit-information`,
      method: "GET",
    });
  },

  getDisbursementDetail: (studentUUID, ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentUUID}/ibr/${(studentUUID, ibrID)}/disbursements`,
      method: "GET",
    });
  },

  requestToReuoload: (stuId, ibrId, data) => {
    // const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${stuId}/ibr/${ibrId}/request-reupload-document/`,
      method: "POST",
      data: data,
    });
  },
  adminActions: (studentId, ibrId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentId}/ibr/${ibrId}/admin-action-detail`,
      method: "GET",
    });
  },
  editNameByAdmin: (studentID, ibrID, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentID}/ibr/${ibrID}/request-name-change/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: form_data,
    });
  },
  nameChangeRequestApproval: (studentId, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentId}/name-change`,
      method: "POST",
      data: form_data,
    });
  },
  nameChangeRequestDocs: (studentId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentId}/ibr/document/`,
      method: "GET",
    });
  },
  emailChange: (studentID, data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentID}/email-change`,
      method: "POST",
      data: formData,
    });
  },

  updateStudentIdentity: (id, ibrId, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${id}/ibr/${ibrId}/admin-approval-status/id/`,
      method: "PATCH",
      data: form_data,
    });
  },

  getTranscriptDetails: (StuId, IsaId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${StuId}/ibr/${IsaId}/transcript/get_detail`,
      method: "GET",
    });
  },

  ResetTranscript: (sId, ibrId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${sId}/ibr/${ibrId}/transcript/reset`,
      method: "GET",
    });
  },

  fraudAlertApproval: (sId, ibrId, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${sId}/ibr/${ibrId}/admin-approval-status/fraud/`,
      method: "PATCH",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  transcriptDocumentApproval: (sId, ibrId, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${sId}/ibr/${ibrId}/admin-approval-status/transcript/`,
      method: "PATCH",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  ssnApproval: (sId, ibrId, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${sId}/ibr/${ibrId}/admin-approval-status/ssn_mismatch/`,
      method: "PATCH",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  incomeDocumentApproval: (sId, ibrId, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${sId}/ibr/${ibrId}/admin-approval-status/income/`,
      method: "PATCH",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getServicers: (studentUUID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_SQS,
      url: `servicer/${studentUUID}/`,
      method: "GET",
    });
  },
  getPaymentHistory: (studentUUID, year, pageNumber, transactionType) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_SQS,
      url: `servicer/${studentUUID}/payment-history/?limit=10&year=${year}&page=${pageNumber}&transaction_type=${transactionType}`,
      method: "GET",
    });
  },
  getPaymentHistoryForGraph: (studentUUID, year, transactionType) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_SQS,
      url: `servicer/${studentUUID}/payment-history-graph/?year=${year}&transaction_type=${transactionType}`,
      method: "GET",
    });
  },

  getIDVerifyDetails: (studentUUID, ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentUUID}/id-verification-details/${ibrID}`,
      method: "GET",
    });
  },
  adminStudentEmail: (ibriD) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/students/mail-history/${ibriD}`,
      method: "GET",
    });
  },
  resendAdminMail: (mail, ibriD) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/resend-email/${ibriD}?mail_type=${mail}`,
      method: "GET",
    });
  },
  adminEmailDetail: (userUUID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `student/${userUUID}/`,
      method: "GET",
    });
  },
  deactiveIBR: (studentID, ibrID, data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentID}/ibr/${ibrID}/deactivate-application`,
      method: "PATCH",
      data: formData,
    });
  },
  deactiveUser: (studentID, data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentID}/deactivate-user`,
      method: "PATCH",
      data: formData,
    });
  },
  ResetIdentity: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/forgot-password/`,
      method: "PATCH",
      data: form_data,
    });
  },
  getNewApplicationStatus: (sId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${sId}/new-application-approval-status/`,
      method: "PATCH",
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getStatusReapply: (sId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${sId}/check-ibrs/`,
      method: "GET",
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  confirmIbrCancellation: (data, isa_id, student_id) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${student_id}/isa/${isa_id}/confirm-cancellation`,
      method: "PATCH",
      data: formData,
    });
  },
  getUser: (uuid, search) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: search ? `users/?search=${search}` : `users/${uuid}/`,
      method: "GET",
    });
  },
  getFundingInvestorHistory: (studentUUID, ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentUUID}/ibr/${ibrID}/investor-history/`,
      method: "GET",
    });
  },
  getAlerts: (studentUUID, ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentUUID}/ibr/${ibrID}/application-alerts`,
      method: "GET",
    });
  },
  getStagesCount: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/stages/`,
      method: "GET",
    });
  },
  sendOneLogo: (sId, ibr) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${sId}/ibr/${ibr}/application`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getStudentExternalVendor: (studentUUID, ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${studentUUID}/ibr/${ibrID}/external-vendors/`,
      method: "GET",
    });
  },

  // getUniversities: (params) => {
  //   return HELPERS.request({
  //     baseURL: process.env.NEXT_PUBLIC_STUDENT,
  //     url: `school?school_type=coding-school`,
  //     method: 'GET',
  //     params,
  //   })
  // },

  createLandingUrl: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/custom-school-landing-page/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    });
  },

  getAllLandingSchools: (landingUrl, searchValue) => {
    const encodedLandingUrl = landingUrl ? encodeURIComponent(landingUrl) : "";
    const encodedSearch = searchValue ? encodeURIComponent(searchValue) : "";
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/custom-school-landing-page/${
        encodedLandingUrl
          ? `?landing_url=${encodedLandingUrl}`
          : encodedSearch
            ? `?search=${encodedSearch}`
            : ""
      }`,
      method: encodedLandingUrl ? "DELETE" : "GET",
    });
  },

  // school landing url details
  getLandingSchoolDetails: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/check-school-landing-page/?uuid=${uuid}`,
      method: "GET",
    });
  },

  editLandingUrl: (data, landingUrl) => {
    const encodedLandingUrl = landingUrl ? encodeURIComponent(landingUrl) : "";
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/custom-school-landing-page/?landing_url=${encodedLandingUrl}`,
      method: "PATCH",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    });
  },

  // sendOneLogo: (studentUUID, ibrID) => {
  //   return HELPERS.secureRequest({
  //     baseURL: process.env.NEXT_PUBLIC_STUDENT,
  //     url: `students/${studentUUID}/ibr/${ibrID}/application`,
  //     method: "POST",
  //     headers: { "Content-Type": "multipart/form-data" },
  //   });
  // },
  sqsHealth: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_SQS,
      url: `consumer/`,
      method: "GET",
    });
  },
  sqsHealthPost: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_SQS,
      url: `consumer/`,
      method: "POST",
      data: formData,
    });
  },
  sqsHealthSend: (data) => {
    const formData = HELPERS.converToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_SQS,
      url: `sqs/`,
      method: "POST",
      data: formData,
    });
  },
  getTermsList: (pageNo, search) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/terms?page=${pageNo}${
        search?.dataIndex ? "&" + search.dataIndex + "=" + search.value : ""
      }`,
      method: "GET",
    });
  },

  codingSchoolResendInvite: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH_V2,
      url: `users/resend-invite/`,
      method: "PATCH",
      data: formData,
    });
  },
  adminRoleList: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/role/`,
      method: "GET",
    });
  },
  generalEnquiries: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `list-general-enquiries/`,
      method: "GET",
    });
  },
  listEnquiries: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `list-enquires/`,
      method: "GET",
    });
  },
  adminList: (pageNo, limit, search) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH_V2,
      url: search
        ? `users/admin/?search=${search}${limit && "&limit=" + limit}${
            pageNo && "&page=" + pageNo
          }`
        : `users/admin/?${limit && "&limit=" + limit}${
            pageNo && "&page=" + pageNo
          }`,
      method: "GET",
    });
  },

  createAdmin: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH_V2,
      url: `users/admin/ `,
      method: "POST",
      data: form_data,
    });
  },
  retrieveAdminList: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH_V2,
      url: `users/admin/?${uuid ? "admin_uuid=" + uuid : ""}`,
      method: "GET",
    });
  },
  deleteAdmin: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH_V2,
      url: `users/admin/?${uuid ? "admin_uuid=" + uuid : ""}`,
      method: "DELETE",
    });
  },
  updateAdminRole: (uuid, data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH_V2,
      url: `users/admin/?${uuid ? "admin_uuid=" + uuid : ""}`,
      method: "PATCH",
      data: data,
    });
  },
  adminSetPassword: (userhash, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.request({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `/users/verify-user/${userhash}/`,
      method: "PATCH",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  adminSetForgotPassword: (userhash, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.request({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `/users/set-password/${userhash}/`,
      method: "POST",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getSchoolType: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `school-type/`,
      method: "GET",
    });
  },
  borrowerActionDetail: (StudentId, IbrId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/ibr/${IbrId}/borrower-actions/`,
      method: "GET",
    });
  },
  roleList: (pageNo) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/role/?limit=10${pageNo ? "&page=" + pageNo : "&page=" + 0}`,
      method: "GET",
    });
  },
  servicesList: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/services/`,
      method: "GET",
    });
  },
  createRole: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/role/`,
      method: "POST",
      data: form_data,
    });
  },
  updateRole: (data, uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/role/?${uuid ? "role_uuid=" + uuid : ""}`,
      method: "PATCH",
      data: data,
    });
  },
  retrieveRole: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/role/?${uuid ? "role_uuid=" + uuid : ""}`,
      method: "GET",
    });
  },
  deleteRole: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: `users/role?${uuid ? "role_uuid=" + uuid : ""}`,
      method: "DELETE",
    });
  },
  memberList: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH,
      url: "users/members/",
      method: "GET",
    });
  },
  oneLogoDownload: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/extract_report/`,
      method: "POST",
      data: form_data,
    });
  },
  certificationHistory: (ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `bank/final-application/history/${ibrID ? ibrID : ""}`,
      method: "GET",
    });
  },
  disbursementHistory: (ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/disbursement-information/history/${ibrID ? ibrID : ""}`,
      method: "GET",
    });
  },
  applicationHistory: (ibrID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/loan-application/history/${ibrID ? ibrID : ""}`,
      method: "GET",
    });
  },

  importHistoryList: (pageNo) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_IMPORT,
      url: `terms-import/terms-import-history-list/?limit=10&page=${pageNo}`,
      method: "GET",
    });
  },

  importHistoryDownload: (batchId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_IMPORT,
      url: `terms-import/terms-import-history/${batchId}/download/`,
      method: "GET",
    });
  },

  uploadImportFile: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_IMPORT,
      url: `terms-import/upload-terms/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    });
  },

  missingRecordList: (uuid, type) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_IMPORT,
      url: `terms-import/list-pending-objects/${uuid}/sheet/?record_type=${type}`,
      method: "GET",
    });
  },
  existingRecordList: (uuid, type) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_IMPORT,
      url: `terms-import/list-existing-objects/${uuid}/sheet/?record_type=${type}`,
      method: "GET",
    });
  },

  updateMissingRecord: (data, uuid) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_IMPORT,
      url: `terms-import/update-program-info/${uuid}/`,
      method: "PATCH",
      data: formData,
      headers: {},
    });
  },

  approveMissingRecord: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_IMPORT,
      url: `terms-import/create_missing_records/${uuid}/`,
      method: "POST",
      headers: {},
    });
  },

  approveTermsRecords: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_IMPORT,
      url: `terms-import/commit-records/${uuid}/`,
      method: "POST",
    });
  },

  declineMissingRecord: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_IMPORT,
      url: `terms-import/reject-batch/${uuid}/`,
      method: "PATCH",
    });
  },

  loanTermList: (pageNo, uuid) => {
    console.log(pageNo, "page", uuid);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_IMPORT,
      url: `terms-import/list-loan-term-staging/${uuid}/?limit=10&page=${pageNo}`,
      method: "GET",
    });
  },
  RetrieveReserveRates: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${id}/advance-rates/?limit=10`,
      method: "GET",
    });
  },
  patchRateChanges: (id, data, selectedID) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${id}/advance-rates/${selectedID}/`,
      method: "PATCH",
      data: formData,
    });
  },
  postRateChanges: (id, data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${id}/advance-rates/`,
      method: "POST",
      data: formData,
    });
  },
  deleteReserveRates: (id, selectedID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${id}/advance-rates/${selectedID}/`,
      method: "DELETE",
    });
  },
  getStaffListCSV: (search) => {
    const newSearchValue = search ? search.replace("+", "%2B") : "";
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `school-staff/export?${newSearchValue ? "search=" + newSearchValue : ""}`,
      method: "GET",
    });
  },
  getTabs: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH_V2,
      url: `users/${id}/dashboard-data/`,
      method: "GET",
    });
  },
  getTabsPatch: (id, data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_AUTH_V2,
      url: `users/${id}/dashboard-data/`,
      method: "PATCH",
      data: data,
    });
  },
  getTransactionType: (ibrid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_SQS,
      url: `servicer/${ibrid}/transaction-type/`,
      method: "GET",
    });
  },
  //refund api's
  createRefundBatch: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `refunds/batch/`,
      method: "POST",
    });
  },
  getRefundBatchList: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      params,
      url: `refunds/batch/`,
      method: "GET",
    });
  },
  exportRefunds: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      params,
      url: `refunds/batch/export/`,
      method: "GET",
    });
  },
  getSingleRefundBatch: (batchId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `refunds/batch/${batchId}`,
      method: "GET",
    });
  },
  getRefundBatchById: (batchId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `refunds/application-refund/${batchId}`,
      method: "GET",
    });
  },
  addStudentRefundBatch: (data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `refunds/application-refund/`,
      data,
      method: "POST",
    });
  },
  refundSent: (data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `refunds/refund-transaction/`,
      data,
      method: "POST",
    });
  },
  reviewRefundSent: (data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `refunds/refund-transaction/`,
      data,
      method: "PATCH",
    });
  },
  searchStudent: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      params,
      url: `students/funded-applications/?status=DISBURSEMENT&bucket=disbursement-funded`,
      method: "GET",
    });
  },
  deleteStudent: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `refunds/application-refund/${uuid}`,
      method: "DELETE",
    });
  },
  editStudent: (uuid, data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `refunds/application-refund/${uuid}`,
      data,
      method: "PATCH",
    });
  },
  deleteBatch: (batchNo) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/refunds/batch/${batchNo}`,
      method: "DELETE",
    });
  },
  calculateRefund: (uuid, params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `refunds/refund-calculator/${uuid}`,
      params,
      method: "GET",
    });
  },
  getExportRefundBatch: (batch_no) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `refunds/application-refund/${batch_no}/csv/`,
      method: "GET",
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  //refund api section end

  //forbearence section API
  getForbearenceList: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      params,
      url: `students/forbearance-requests-admin/`,
      method: "GET",
    });
  },
  getForbearenceServicerFiles: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      params,
      url: `students/forbearance-requests/servicer-document-list/`,
      method: "GET",
    });
  },
  exportForbearenceList: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      params,
      url: `students/forbearance-requests-admin/export/`,
      method: "GET",
    });
  },
  getForbearenceDetail: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${uuid}/forbearance-requests-admin/detail`,
      method: "GET",
    });
  },
  patchForbearenceDetail: (uuid, data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/${uuid}/forbearance-requests-admin/detail`,
      method: "PATCH",
      data,
      params: { uuid },
    });
  },
  getForbearanceTypes: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/forbearance-types/`,
      method: "GET",
    });
  },
  getForbearanceReasons: (params = {}) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/forbearance-reasons/`,
      method: "GET",
      params,
    });
  },
  getForbearanceVerificationCriteria: (forbearanceReasonUuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/forbearance-requests-admin/verification-criteria/`,
      method: "GET",
      params: { forbearance_reason: forbearanceReasonUuid },
    });
  },
  getForbearanceNotes: (loanApplicationUuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/forbearance-notes/`,
      method: "GET",
      params: {
        loan_application: loanApplicationUuid,
      },
    });
  },
  postForbearanceNote: (data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/forbearance-notes/`,
      method: "POST",
      data,
    });
  },
  patchForbearanceAdminAction: (studentID, ibrId, data) => {
    const payload = Array.isArray(data) ? data : [data];
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentID}/ibr/${ibrId}/forbearance-admin-action/`,
      method: "PATCH",
      data: payload,
    });
  },
  getIbrPaymentHistory: (studentUUID, ibrID, params = {}) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentUUID}/ibr/${ibrID}/payment-history/`,
      method: "GET",
      params: {
        limit: 10,
        page: 1,
        year: "",
        transaction_type: "",
        ...params,
      },
    });
  },
  getForbearanceRequestsByLoan: (studentUUID, loanApplicationUUID) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/forbearance-requests/list-create/`,
      method: "GET",
      params: {
        student_uuid: studentUUID,
        loan_application_uuid: loanApplicationUUID,
      },
    });
  },
  patchforbearanceAction: (studentID, ibrId, data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${studentID}/ibr/${ibrId}/admin-approval-status/FORBEARANCE/`,
      method: "PATCH",
      data,
    });
  },
  getForbearanceDocumentList: (forBId, params = {}) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/forbearance-requests/documents-list/`,
      method: "GET",
      params: {
        uuid: forBId,
        ...params,
      },
    });
  },
  getCalcEstimation: (params) => {
    return HELPERS.request({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/loan-calculation`,
      params,
      method: "GET",
    });
  },

  // product DTI Tier
  getProductDtiTier: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/dti-tiers/`,
      method: "GET",
    });
  },
  postProductDtiTier: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/dti-tiers/`,
      data: form_data,
      method: "POST",
    });
  },
  patchProductDtiTier: (id, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/dti-tiers/${id}/`,
      data: form_data,
      method: "PATCH",
    });
  },
  deleteProductDtiTier: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/dti-tiers/${id}/`,
      method: "DELETE",
    });
  },
  CreateAdminAction: (ibr_uuid, action_type) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `/students/${ibr_uuid}/admin-action-create/${action_type}/`,
      method: "POST",
    });
  },

  createDisbursementBatch: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `bank/disbursement-batches/`,
      data: formData,
      method: "POST",
    });
  },
  getDisbursementBatches: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `bank/disbursement-batches/`,
      params,
      method: "GET",
    });
  },

  getDisbursementBatcheDetail: (params, batchUuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `bank/disbursement-batches/${batchUuid}/applications/`,
      params,
      method: "GET",
    });
  },

  getDisbursementBatcheBucketsDetail: (params, batchUuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `bank/disbursement-batches/${batchUuid}/`,
      params,
      method: "GET",
    });
  },

  getDisbursementRecords: (batchNumber) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/bulk-disbursement-records/${batchNumber}`,
      method: "GET",
    });
  },

  processBatchesToBank: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/process-batches-to-bank/`,
      data: formData,
      method: "POST",
    });
  },

  recalculateTotals: (batch_id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `bank/disbursement-batches/${batch_id}/recalculate-totals/`,
      data: { store: true },
      method: "POST",
    });
  },

  processBatchesToServicer: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/process-batches-to-servicer/`,
      data: formData,
      method: "POST",
    });
  },

  deleteBatchApplication: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `bank/disbursement-batches/applications/${id}/remove/`,
      method: "DELETE",
    });
  },

  exportBatches: (params, batchUuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `bank/disbursement-batches/${batchUuid}/applications-export/`,
      params,
      method: "GET",
    });
  },

  addToBatchList: (data, batchId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `bank/disbursement-batches/${batchId}/`,
      method: "PATCH",
      data,
    });
  },

  getMissingData: (batchNumber) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `bank/missing-data/${batchNumber}/`,
      method: "GET",
    });
  },
  deleteTerm: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `loan-terms/${id}/`,
      method: "DELETE",
    });
  },

  // Product Interest Rates
  getInterestRate: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/interest-rates/`,
      params,
      method: "GET",
    });
  },

  deleteInterestRate: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/interest-rates/${id}/`,
      method: "DELETE",
    });
  },

  postInterestRate: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/interest-rates/`,
      data: formData,
      method: "POST",
    });
  },

  patchInterestRate: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/interest-rates/bulk-update/`,
      data: data,
      method: "PATCH",
    });
  },

  // product DTI Tier
  getDtiTier: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/dti-tiers/`,
      params,
      method: "GET",
    });
  },

  deleteDtiTier: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/dti-tiers/${id}/`,
      method: "DELETE",
    });
  },

  postDtiTier: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/dti-tiers/`,
      data: form_data,
      method: "POST",
    });
  },

  patchDtiTier: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/dti-tiers/update-dti-tiers/`,
      data: data,
      method: "PATCH",
    });
  },

  //General Overview
  getGeneralOverview: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/loan-product-overview`,
      params,
      method: "GET",
    });
  },

  patchGeneralOverview: (data, loanType) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/loan-product-overview/?loan_type=${loanType}`,
      data: data,
      method: "PATCH",
    });
  },

  getLoanProductList: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/loan-product-overview-list/`,
      method: "GET",
    });
  },

  // FICO TIER

  getFICOTier: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/fico-tier`,
      params,
      method: "GET",
    });
  },

  patchFICOTier: (uuid, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/fico-tier/${uuid}/`,
      data: form_data,
      method: "PATCH",
    });
  },

  // Advance Rate

  getAdvanceRateSets: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/advance-rate-sets`,
      params,
      method: "GET",
    });
  },

  getIndividualSet: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/advance-rate-sets/${uuid}`,
      method: "GET",
    });
  },

  postAdvanceRateSets: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/advance-rate-sets/`,
      data: formData,
      method: "POST",
    });
  },

  patchAdvanceRateSets: (data, id) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/advance-rate-sets/${id}/`,
      data: form_data,
      method: "PATCH",
    });
  },

  deleteAdvanceRateSets: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/advance-rate-sets/${id}/`,
      method: "DELETE",
    });
  },

  patchBaseAdvanceRate: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/update-base-advance-rates/`,
      data: data,
      method: "PATCH",
    });
  },

  deleteBaseAdvanceRate: (id) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/base-advance-rates/${id}/`,
      method: "DELETE",
    });
  },

  postBaseAdvanceRate: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/base-advance-rates/`,
      data: formData,
      method: "POST",
    });
  },

  assignAdvanceRates: (id, data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${id}/assign-advance-rates/`,
      method: "POST",
      data: formData,
    });
  },

  uploadIndustryFile: (data, params) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/industry-data-upload/`,
      method: "POST",
      params,
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    });
  },

  getIndustryData: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/industries/`,
      params,
      method: "GET",
    });
  },

  getIndustryList: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/industry-list/`,
      method: "GET",
    });
  },

  postIndustry: (data) => {
    const formData = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/industries/`,
      method: "POST",
      data: formData,
    });
  },

  deleteIndustry: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/industries/${uuid}/`,
      method: "DELETE",
    });
  },

  exportIndustry: () => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/industry-data-export/`,
      method: "GET",
    });
  },

  putSalaryForecasts: (uuid, data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/industries/${uuid}/salary-forecasts/`,
      method: "PUT",
      data: data,
    });
  },

  putSalaryBands: (uuid, data) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/industries/${uuid}/salary-bands/`,
      method: "PUT",
      data: data,
    });
  },

  patchIndustry: (uuid, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `students/industries/${uuid}/`,
      data: form_data,
      method: "PATCH",
    });
  },

  postRecertification: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/ibr/${uuid}/move-to-recertification/`,
      method: "POST",
    });
  },

  updateSupplementalAddendum: (id, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT,
      url: `school-list/${id}/supplemental-addendum/`,
      data: form_data,
      method: "PATCH",
    });
  },

  getIncomeVerification: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/borrower-income-verification/`,
      params,
      method: "GET",
    });
  },

  exportIncomeVerification: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/borrower-income-verification/export/`,
      params,
      method: "GET",
      responseType: "blob",
    });
  },

  retriveIncomeVerification: (uuid, params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/borrower-income-verification/${uuid}`,
      params,
      method: "GET",
    });
  },

  getIncomeVerificationLoanDetails: (uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/borrower-income-verification/${uuid}/loan-details/`,
      method: "GET",
    });
  },

  patchIncomeVerification: (biv_uuid, data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/borrower-income-verification/${biv_uuid}/action/`,
      data: form_data,
      method: "PATCH",
    });
  },

  calculateVerifiedAnnualIncome: (data) => {
    const form_data = HELPERS.convertToFormData(data);
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/borrower-income-verification/calculate-verified-annual-income/`,
      data: form_data,
      method: "POST",
    });
  },

  getIncomeServicerApprovalFiles: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/borrower-income-verification/servicer-document-list/`,
      params,
      method: "GET",
    });
  },

  verifyIncomeEligibility: (student_uuid, ibr_uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${student_uuid}/ibr/${ibr_uuid}/verify-income-eligibility/`,
      method: "PATCH",
    });
  },

  reverifyIncome: (student_uuid, ibr_uuid) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_STUDENT_V2,
      url: `students/${student_uuid}/ibr/${ibr_uuid}/reverify-income-eligibility/`,
      method: "PATCH",
    });
  },

  // Edly AI - MCP Server APIs
  getMcpUsers: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_MCP_API,
      url: `users`,
      params,
      method: "GET",
    });
  },
  getMcpUser: (userId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_MCP_API,
      url: `users/${userId}`,
      method: "GET",
    });
  },
  getMcpLogs: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_MCP_API,
      url: `logs`,
      params,
      method: "GET",
    });
  },
  getMcpLogDetail: (logId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_MCP_API,
      url: `logs/${logId}`,
      method: "GET",
    });
  },
  getMcpFeedback: (params) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_MCP_API,
      url: `feedback`,
      params,
      method: "GET",
    });
  },
  getMcpFeedbackDetail: (feedbackId) => {
    return HELPERS.secureRequest({
      baseURL: process.env.NEXT_PUBLIC_MCP_API,
      url: `feedback/${feedbackId}`,
      method: "GET",
    });
  },
};

export default API_MANAGER;
